import { StatusCodes } from "http-status-codes"
import { useCallback, useMemo } from "react"
import { toast } from "react-toastify"
import { useDeleteConfirm } from "../../../../../../../hooks/useDeleteConfirm"
import { digitalManagerApi } from "../../../../../../../services/api"
import { ApplicationRoleDetail } from "../../../../../../models/ApplicationRole"
import {
  AccessLevel,
  DimaFeatureShortNameEnum,
  hasUserAccessToFeature,
} from "../../../../../../models/Authorization"
import { DeviceRolePermissionGet } from "../../../../../../models/DeviceRolePermission"
import { UserInfo } from "../../../../../../models/User"
import { DiMaAddButton } from "../../../../../partials/DiMaAddButton"
import { EntityRow, EntityTab } from "../../../../../partials/EntityTab"

export function DeviceRolePermissionApplicationRoles(props: {
  readonly deviceRolePermission: DeviceRolePermissionGet
  readonly reloadDeviceRolePermission: () => void
  readonly user: UserInfo
}) {
  const { deviceRolePermission, reloadDeviceRolePermission, user } = props
  const { requestDelete, DeleteConfirmDialog } = useDeleteConfirm()

  const handleDelete = useCallback(
    (id: string) => {
      requestDelete(() => {
        digitalManagerApi
          .delete(
            `/devices/${deviceRolePermission.device.id}/roles/${deviceRolePermission.role.id}/permissions/${deviceRolePermission.permission.id}/applicationRoles/${id}`
          )
          .then((res) => {
            if (res.status === StatusCodes.OK) {
              toast.success("Application roles deleted")
            }
          })
          .catch(() => toast.error("Cannot delete the application role"))
          .finally(() => reloadDeviceRolePermission())
      })
    },
    [
      deviceRolePermission.device.id,
      deviceRolePermission.permission.id,
      deviceRolePermission.role.id,
      reloadDeviceRolePermission,
      requestDelete,
    ]
  )

  const cols = [{ field: "name", headerName: "Role" }]

  const canDelete = hasUserAccessToFeature(
    user.authorizations,
    DimaFeatureShortNameEnum.DM,
    AccessLevel.Write
  )
  const rows = deviceRolePermission.applicationRoles.map(
    (applicationRole: ApplicationRoleDetail) => ({
      id: applicationRole.id,
      name: applicationRole.name,
    })
  )

  const toolbar = useMemo(
    () => (
      <DiMaAddButton
        url={`/devices/${deviceRolePermission.device.id}/roles/${deviceRolePermission.role.id}/permissions/${deviceRolePermission.permission.id}/applicationRoles/create`}
        feature={DimaFeatureShortNameEnum.AM}
      />
    ),
    [
      deviceRolePermission.device.id,
      deviceRolePermission.role.id,
      deviceRolePermission.permission.id,
    ]
  )

  const handleActionMenuClick = useCallback(
    (item: { title: string }, row: EntityRow) => {
      if (item.title === "Delete") {
        handleDelete(row.id)
      }
    },
    [handleDelete]
  )

  return (
    <>
      {DeleteConfirmDialog}
      <EntityTab
      rows={rows}
      cols={cols}
      isLoading={false}
      toolbar={toolbar}
      actionItems={
        canDelete ? [{ title: "Delete", iconName: "icon_abb_dias icon-abb_delete" }] : []
      }
      onActionMenuClick={handleActionMenuClick}
    />
    </>
  )
}
